import {listSupplierOffers} from "@project/sdk/engineering";
import {ListSupplierOffersResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";
import {ZodError} from "zod";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierOfferKeys} from "../../../supplierOffer-keys";
import type {ListSupplierOffersSearchInput} from "./list-supplier-offers.schema";

import {listSupplierOffersSearchSchema} from "./list-supplier-offers.schema";

export function listSupplierOffersQueryOptions(rawInput: ListSupplierOffersSearchInput) {
  const params = listSupplierOffersSearchSchema.parse(rawInput);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: supplierOfferKeys.list(params),
    queryFn: async ({signal}) => {
      const parsed = ListSupplierOffersResponse.parse(await listSupplierOffers(params, {signal}));
      for (const [index, item] of parsed.items.entries()) {
        if (
          item.pricingStatus === "UNPRICED"
            ? item.terms !== undefined || item.selectableForCustomerOffer
            : item.terms === undefined ||
              item.selectableForCustomerOffer !== item.eligibleForCatalogSupply
        ) {
          throw new ZodError([
            {
              code: "custom",
              path: ["items", index, "terms"],
              message: "Supplier Offer pricing projection is inconsistent.",
            },
          ]);
        }
      }
      return parsed;
    },
  });
}
